/** JWT `exp` claim in milliseconds since epoch, or null if missing/invalid. */
export function getJwtExpiryMs(token: string): number | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const decoded = JSON.parse(atob(payload)) as { exp?: number };
    return typeof decoded.exp === 'number' ? decoded.exp * 1000 : null;
  } catch {
    return null;
  }
}

/** True when the token is missing, malformed, or past expiry (optional clock skew). */
export function isJwtExpired(token: string, skewMs = 30_000): boolean {
  const exp = getJwtExpiryMs(token);
  if (exp == null) {
    return true;
  }
  return Date.now() >= exp - skewMs;
}
